// extracted by mini-css-extract-plugin
module.exports = {"inputMask":"InputMaskField_inputMask__2RZo9","empty":"InputMaskField_empty__1u1-P"};